<template>
  <a-modal v-model:visible="dialogVisible"
           :width="windowWidth"
           class="xm-char-data-config"
           @ok="handleOk"
           :footer="false"
           :title="windowTitle">
    <a-skeleton v-if="!showPageFlag" />
    <iframe  v-show="showPageFlag"  :src="windowUrl"
             style="height: 100%;border:0;"
             :style="iframeSty" @load="loadPage" width="100%"></iframe>

  </a-modal>
</template>


<script lang="ts">
import {defineComponent} from 'vue';


export default defineComponent({
  name: 'drill-chars-sel-win',
});
</script>

<script lang="ts" setup>
import {useVModel} from "@vueuse/core";
import {useI18n} from "vue-i18n";

const {t} = useI18n();

const showPageFlag=ref(false);
const loadPage=function (){
  showPageFlag.value=true;
}

interface propsType{
  visible:boolean,
  windowUrl:string,
  windowHeight:number,
  windowWidth:number,
  windowTitle:string,
}
const props = withDefaults(defineProps<propsType>(),{
  visible: false,
  windowUrl:'',
  windowHeight:400,
  windowWidth:600,
  windowTitle:'窗口标题',
})

const iframeSty=computed(()=>{
  return {height:props.windowHeight+"px"}
})

const emits = defineEmits(['update:visible', 'handleOk', 'closeWin']);
const dialogVisible = useVModel(props, 'visible', emits);

const handleOk = () => {
  emits('handleOk', {})
}


</script>

<style lang="less">
.xm-char-data-config{
  .ant-modal-body{
    padding: 0;
  }
}
</style>
